// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--EakdZ","info-block":"_02712f2b3b--info-block--v4y5S"};